module.exports = __webpack_public_path__ + "static/img/popu_bg.c8b2b57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/popu_bg.jpg
// module id = VVBG
// module chunks = 0